import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import {Provider} from "react-redux"
import store from './store';

import "./font/Museo Sans 700.ttf";
import "./font/Museo Sans 300 Regular.ttf";

import ContextWrapper from "./contextCalendar/ContextWrapper"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <BrowserRouter>
  <ChakraProvider>
  <ContextWrapper>
    <App />
    </ContextWrapper>
  </ChakraProvider>
</BrowserRouter>
</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
